import { render, staticRenderFns } from "./FormTres.vue?vue&type=template&id=53c13e3d&scoped=true&"
import script from "./FormTres.vue?vue&type=script&lang=js&"
export * from "./FormTres.vue?vue&type=script&lang=js&"
import style0 from "./FormTres.vue?vue&type=style&index=0&id=53c13e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c13e3d",
  null
  
)

export default component.exports